module.exports = __webpack_public_path__ + "media/21.2b710c20.mp3";